import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {cn} from '@containers/html-utils'
import {BgOpacityContainer} from '../bg-opacity-container/bg-opacity-container'

const TwCell = tw.div`
  w-28 
  h-28
  flex
  justify-center
  items-center
  rounded-full
  text-12
  border
  border-solid
  border-transparent
  group-hover:border-action-hover
`

export const DayOfWeekChooser = ({
  className,
  value,
  onChange
}: {
  value: number[]
  onChange: (days: number[]) => void
  className?: string
}) => {
  const toggleDayOfWeek = (day: number) => {
    const selected = value.includes(day)
    const newValue = selected ? value.filter(v => v !== day) : [...value, day]
    onChange(newValue)
  }
  return (
    <div className={cn('flex', className)}>
      {Util.range(0, 7).map(day => (
        <DayCell
          key={day}
          day={day}
          selected={value.includes(day)}
          onClick={() => toggleDayOfWeek(day)}
        />
      ))}
    </div>
  )
}

type DayCellProps = {
  day: number
  selected: boolean
  onClick: () => void
}

const DayCell = ({day, selected, onClick}: DayCellProps) => {
  const bgClassName = cn(
    selected && 'bg-action-default font-semibold rounded-r-full rounded-l-full'
  )
  return (
    <div className="cursor-pointer w-28 h-28 group" onClick={onClick}>
      <BgOpacityContainer
        bgColorClassName={bgClassName}
        bgOpacityClassName="opacity-40"
      >
        <TwCell>{Lang.msg.weekNamesShort[day]}</TwCell>
      </BgOpacityContainer>
    </div>
  )
}
